import React from 'react'
import JobSeekerHeading from '../JobSeekerHeading'
import styles from './TakingTest.module.scss'

const TakingTest = () => {
  return (
    <div className={styles.main}>
      <div className={`${styles.container} `}>
        <div className={`${styles.inner} px-sm-5 py-3`}>
          <JobSeekerHeading title="TAKING THE TEST" />
          <div className={`${styles.section} d-flex justify-content-center`}>
            <div className={styles.sec}>
              <img
                src="/taking-the-test.svg"
                alt="taking-the-test"
                width="100%"
                height="100%"
              />
            </div>
            <div className={styles.test}>
              <h3>TAKING THE TEST</h3>
              <span>
                You should work quickly and
                <br />
                accurately through the{' '}
                <a rel="nofollow" href="https://l.linklyhq.com/l/O0fY">
                  test
                </a>
                .
              </span>
              <p>
                Don’t get stuck on any particular question: should you have any
                problems, return to it at the end of the{' '}
                <a
                  rel="nofollow"
                  href="https://l.linklyhq.com/l/O0fY"
                  className="Linkly"
                >
                  test
                </a>
                . You should divide your time per question as accurately as you
                can – typically this will be between{' '}
                <span>50 and 90 seconds per question.</span>
              </p>
            </div>
          </div>
          <div className={styles.belowSection}>
            <strong>
              Remember that the{' '}
              <a rel="nofollow" href="https://l.linklyhq.com/l/O0fY">
                tests
              </a>{' '}
              are difficult and often you will not he expected to answer all the
              questions.
            </strong>
            Be particularly cautious if the
            <a href="https://www.practicereasoningtests.com//practice-aptitude-tests">
              aptitude test
            </a>{' '}
            uses negative marking; if this is not the case, answer as many
            questions as possible in the time given.
            <p>
              Remember that multiple-choice options are often designed to
              mislead you, with incorrect choices including common mistakes that
              candidates make.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TakingTest
